import * as yup from "yup";
import { InvoiceValidationSchemaCL } from "./types";

const requiredString = yup.string().required("");
const optionalString = yup.string().optional();

const invoiceNumber = (save: boolean) =>
  yup
    .string()
    .concat(save ? optionalString : requiredString);

const invoiceType = (save: boolean) =>
  yup.object({
    name: yup.string().concat(save ? optionalString : requiredString),
  });

const emisionDate = (save: boolean) =>
  yup
    .string()
    .test("requireDatePicker", "", (value) => (save ? true : !!value));

export const validationSchemaCL = (
  save: boolean
): yup.SchemaOf<InvoiceValidationSchemaCL> => {
  return yup.object({
    emisionDate: emisionDate(save),
    invoiceType: invoiceType(save),
    invoiceNumber: invoiceNumber(save),
  });
};
